
const SET_CUSTOMER = function (state, { customernumber, email, affiliateId, subs }) {
  state.id = customernumber
  state.affiliateId = affiliateId
  state.subs = subs
  state.email = email
  state.customerId = customernumber
  window.$cookies.set('_uid', email, '1D')
  this._vm.$ea.affiliateInfo.email = email
  this._vm.$ea.affiliateInfo.id = affiliateId
  this._vm.$ea.affiliateInfo.customerid = customernumber
  this._vm.$ea.trackEvent({ type: 'user_agent', value: { platform: navigator.userAgent } })
}

const SET_MESSAGE = function (state, { message, messageVariant, messageSent }) {
  state.contactForm.message = message
  state.contactForm.messageVariant = messageVariant
  state.contactForm.messageSent = messageSent
}

export default {
  SET_CUSTOMER,
  SET_MESSAGE
}
